import { render, staticRenderFns } from "./CreateKlaimPd.vue?vue&type=template&id=c9ebc13a&scoped=true&"
import script from "./CreateKlaimPd.vue?vue&type=script&lang=js&"
export * from "./CreateKlaimPd.vue?vue&type=script&lang=js&"
import style0 from "./CreateKlaimPd.vue?vue&type=style&index=0&id=c9ebc13a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9ebc13a",
  null
  
)

export default component.exports